import React from "react";

const base = {
	width: 18,
	height: 18,
	viewBox: "0 0 24 24",
	fill: "none",
	stroke: "currentColor",
	strokeWidth: 1.8,
	strokeLinecap: "round",
	strokeLinejoin: "round",
};

export function IconMail(props) {
	return (
		<svg {...base} {...props}>
			<rect x='3' y='5' width='18' height='14' rx='2' />
			<path d='M3 7l9 6 9-6' />
		</svg>
	);
}

export function IconLock(props) {
	return (
		<svg {...base} {...props}>
			<rect x='4' y='11' width='16' height='10' rx='2' />
			<path d='M8 11V7a4 4 0 0 1 8 0v4' />
		</svg>
	);
}

export function IconEyeOpen(props) {
	return (
		<svg {...base} {...props}>
			<path d='M1 12s4-7 11-7 11 7 11 7-4 7-11 7-11-7-11-7Z' />
			<circle cx='12' cy='12' r='3' />
		</svg>
	);
}

export function IconEyeOff(props) {
	return (
		<svg {...base} {...props}>
			<path d='M3 3l18 18' />
			<path d='M10.6 5.1A11 11 0 0 1 12 5c7 0 11 7 11 7a17.9 17.9 0 0 1-3.4 4.3M6.4 6.4A17.6 17.6 0 0 0 1 12s4 7 11 7a10.6 10.6 0 0 0 4.2-.9' />
			<path d='M9.9 9.9a3 3 0 0 0 4.2 4.2' />
		</svg>
	);
}

export function IconClose(props) {
	return (
		<svg {...base} {...props}>
			<path d='M5 5l14 14M19 5L5 19' />
		</svg>
	);
}

export function IconArrowLeft(props) {
	return (
		<svg {...base} {...props}>
			<path d='M19 12H5M11 6l-6 6 6 6' />
		</svg>
	);
}

export function IconUser(props) {
	return (
		<svg {...base} {...props}>
			<circle cx='12' cy='8' r='4' />
			<path d='M4 21c0-4 4-6 8-6s8 2 8 6' />
		</svg>
	);
}
